"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Classe para alterar a visibildade de uma caixa ao ser clicada
 *
 * @param {string} toggle - Seletor CSS do botão que ao ser clicado exibe/esconde uma caixa
 * @param {string} box - Seletor CSS da caixa que será exibida/escondida
 * @param {boolean} isNavigation - opção que informa se a caixa é a navegação principal
 */
var TopDropdown =
/*#__PURE__*/
function () {
  function TopDropdown(_ref) {
    var toggle = _ref.toggle,
        box = _ref.box,
        _ref$isNavigation = _ref.isNavigation,
        isNavigation = _ref$isNavigation === void 0 ? false : _ref$isNavigation;

    _classCallCheck(this, TopDropdown);

    // Botão que ao ser clicado exibe/esconde a caixa
    this.$toggle = $(toggle); // Caixa que será exibida/escondida

    this.$box = $(box); // Opção que informa se a caixa é a navegação principal

    this.isNavigation = isNavigation; // Elemento Window

    this.$window = $(window); // Tempo que animação deve durar

    this.slideDuration = 200;
    this.listeners();
  }

  _createClass(TopDropdown, [{
    key: "listeners",
    value: function listeners() {
      var _this = this;

      this.$toggle.click(function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.$toggle.toggleClass('is-active');

        _this.$box.slideToggle(_this.slideDuration);
      });
      this.$box.click(function (event) {
        event.stopPropagation();
      });
      this.$window.click(function () {
        // Caso a caixa que será exibida/escondida seja a navegação principal,
        // o botão só funcionará no responsivo
        if (_this.isNavigation) {
          if (_this.$box.css('position') === 'absolute') {
            _this.close();
          }
        } else {
          _this.close();
        }
      });
    }
    /**
     * Método que vai retirar a classe do botão e da caixa
     */

  }, {
    key: "close",
    value: function close() {
      this.$toggle.removeClass('is-active');
      this.$box.slideUp(this.slideDuration);
    }
  }]);

  return TopDropdown;
}();